import { Stack, styled } from "@mui/material";

export const AuthLayoutWrapper = styled(Stack)(({ theme }) => {
    return {
        flexDirection: "row",
        minHeight: "100vh",
        "& .logo-box": {
            flex: 1,
            overflow: "hidden",
            padding: "var(--basic-padding)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "linear-gradient(to right, #791377 16%, #A91BA6 53%, #DF23DB 100%)",
            [theme.breakpoints.down("laptop")]: {
                display: "none",
            }
        },
        "& .form-box": {
            flex: 1,
            overflow: "hidden",
            padding: "var(--basic-padding)",
            paddingBottom: "calc(var(--basic-padding) * 2)",
            "& .favicon-box": {
                overflow: "hidden",
            }
        },
        [theme.breakpoints.up("laptop")]: {
            "& .form-box": {
                padding: "calc(var(--basic-padding) * 2)",
            },
            "& .logo-box": {
                padding: "calc(var(--basic-padding) * 2)",
            }
        }
    }
})